import { IReleaseNote } from '../models/ReleaseNote'
import note20260501JobsUpdate from './2026-05-01-jobs-update.json'
import note20260601ReopenAssessments from './2026-06-01-reopen-assessments.json'
import note20260701TeamProgress from './2026-07-01-team-progress.json'
import note20260701JobSetupExports from './2026-07-01-job-setup-exports.json'
import note20260801Collections from './2026-08-01-collections.json'
import note20260901EmployerBranding from './2026-09-01-employer-branding.json'
import note20260901Activity from './2026-09-01-activity.json'
import note20260915JobMatrix from './2026-09-15-job-matrix.json'
import note20260915TeamResults from './2026-09-15-team-results.json'
import note20261001EmployerBrandingCulture from './2026-10-01-employer-branding-culture.json'
import note20261001RequestsAndActivity from './2026-10-01-requests-and-activity.json'
import noteDraft from './draft.json'

// The launch migration seeds every existing member's `since` with it: notes
// published after it are unread at launch (the newest pops), older (backfilled)
// notes count as already seen.
export const RELEASE_NOTES_LAUNCH_DATE: string | undefined =
  '2026-08-31T00:00:00.000Z'

// Every published release note. Add a note as <id>.json next to this file and
// register it here — written by the /release-notes skill.
const releaseNotes: IReleaseNote[] = [
  note20260501JobsUpdate as IReleaseNote,
  note20260601ReopenAssessments as IReleaseNote,
  note20260701TeamProgress as IReleaseNote,
  note20260701JobSetupExports as IReleaseNote,
  note20260801Collections as IReleaseNote,
  note20260901EmployerBranding as IReleaseNote,
  note20260901Activity as IReleaseNote,
  note20260915JobMatrix as IReleaseNote,
  note20260915TeamResults as IReleaseNote,
  note20261001EmployerBrandingCulture as IReleaseNote,
  note20261001RequestsAndActivity as IReleaseNote,
  noteDraft as IReleaseNote,
]

export default releaseNotes
